import Button from "../../../../design-system/primitives/components/Button/Button";
import Text from "../../../../design-system/primitives/components/Text/Text";
import styles from "./chatParts.css";

type SuggestionsProps = {
  suggestions: string[];
  onSelect: (suggestion: string) => void;
  disabled?: boolean;
  variant?: "button" | "bubble";
};

export const Suggestions = ({
  suggestions,
  onSelect,
  disabled,
  variant = "button",
}: SuggestionsProps) => {
  if (suggestions.length === 0) return null;

  return (
    <ul className={styles.suggestions} aria-label="Vorschläge für Fragen">
      {suggestions.map((suggestion) => (
        <li key={suggestion}>
          {variant === "bubble" ? (
            <button
              type="button"
              className={styles.suggestionBubble}
              disabled={disabled}
              onClick={() => onSelect(suggestion)}
            >
              <Text variant="body" as="span">
                {suggestion}
              </Text>
            </button>
          ) : (
            <Button
              title={suggestion}
              size="small"
              variant="secondary"
              disabled={disabled}
              onClick={() => onSelect(suggestion)}
            />
          )}
        </li>
      ))}
    </ul>
  );
};
